// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { getHasPermissions } from 'speed-js-react/src/redux/auth/selector';
import '../styles/tooltip.less';

const permissionRequired = (permissions?: Array<string>) => (
    (
        Component: React.ComponentType<Object>,
    ): React.AbstractComponent<Object> => {
        type Props = {
            permissions: Array<string>,
            hasPermissions: boolean,
            forwardedRef: React.Ref,
        }
        const dummyProps = permissions ? { permissions } : undefined;

        const mapStateToProps = (state, props) => ({
            hasPermissions: getHasPermissions(state, dummyProps || props),
        });

        class RequirePermissions extends React.Component<Props> {
            render() {
                const { hasPermissions, forwardedRef, ...props } = this.props;
                if (hasPermissions) {
                    return (
                        <>
                            <Component {...props} ref={forwardedRef} />
                            <ReactTooltip
                                id="permission-required"
                                effect="solid"
                                place="right"
                                className="react-tooltip"
                            />
                        </>
                    );
                }

                return null;
            }
        }

        RequirePermissions.displayName = `permissionRequired(${Component.displayName || Component.name || ''})`;

        return connect(mapStateToProps, null, null, { forwardRef: true })(
            // eslint-disable-next-line react/no-multi-comp
            React.forwardRef(
                (props, ref) => (
                    <RequirePermissions {...props} forwardedRef={ref} />
                ),
            ),
        );
    }
);


export default permissionRequired;
